import {useState} from "react";
import {useNavigate} from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import moment from "moment";
import "moment-timezone";

import IconBool from "components/IconBool";
import ConditionalRender from "components/ConditionalRender";
import CopyToClipTextarea from "components/copyToClipboard/CopyToClipTextarea";
import useCustomTranslation from "core/customTranslation";
import axiApi from "ApiCaller";

const translation = {
    es: {
        queue: "Cola",
        updated: "Actualizado",
        sended: "Enviado",
        confirmed: "Confirmado",
        "sent.short": "E",
        "confirmed.short": "C",
        device: "Dispositivo",
        close: "Cerrar",
        clean: "Limpiar",
        "message.error": "No se ha podido limpiar la cola.",
    },
    en: {
        queue: "Queue",
        updated: "Updated",
        sended: "Sent",
        confirmed: "Confirmed",
        "sent.short": "S",
        "confirmed.short": "C",
        device: "Device",
        close: "Close",
        clean: "Clean",
        "message.error": "Error cleaning queue.",
    },
};

const ModalViewPayload = ({show, setShow, item}) => {
    const {t: _TC} = useCustomTranslation(translation);
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    const handleClose = () => {
        setShow(false);
    };

    const handleClean = () => {
        const dataSend = {
            uuid: item.uuid,
            topic: item.topic,
        };
        axiApi.post(`/api/devices/clean/queue/`, dataSend).then((resp) => {
            if (resp.status) {
                navigate(0);
            } else {
                setShowError(true);
            }
        });
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} animation={true}>
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="circle" style={item.status ? {color: "#ff9090"} : {color: "#95ca6d"}} />
                </div>
                <div className="preview-title">
                    <Modal.Title>
                        <div>
                            <div>{_TC("device")}</div>
                            <div>
                                <small className="h5">{item.uuid}</small>
                            </div>
                        </div>
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-6">
                            <div>
                                <label>
                                    <strong>{_TC("queue")}:</strong>
                                    <FontAwesomeIcon
                                        icon="circle"
                                        className="ms-2"
                                        style={item.status ? {color: "#ff9090"} : {color: "#95ca6d"}}
                                    />
                                </label>
                            </div>
                            <div>
                                <label>
                                    <strong>Topic:</strong> {item.topic}
                                </label>
                            </div>
                        </div>
                        <div className="col-6 text-end">
                            <div>
                                <label className="me-2">
                                    <strong>{_TC("updated")}:</strong>
                                </label>
                                <span>{moment(item.updated_at).format("DD-MM-YYYY HH:mm")}</span>
                            </div>
                            <ConditionalRender condition={!item.ack_at && item.sent_at}>
                                <div>
                                    <label className="me-2">
                                        <strong>{_TC("sended")}:</strong>
                                    </label>
                                    <span>{moment(item.sent_at).format("DD-MM-YYYY HH:mm")}</span>
                                </div>
                            </ConditionalRender>
                            <ConditionalRender condition={item.ack_at}>
                                <div>
                                    <label className="me-2">
                                        <strong>{_TC("confirmed")}:</strong>
                                    </label>
                                    <span>{moment(item.ack_at).format("DD-MM-YYYY HH:mm")}</span>
                                </div>
                            </ConditionalRender>
                            <div>
                                <strong>Modo:</strong> <span className="me-4">{item.mode}</span>
                                <span title={_TC("sent")} className="me-3">
                                    {_TC("sent.short")} {<IconBool value={item.sent} />}
                                </span>
                                <span title={_TC("confirm.confirmed")}>
                                    {_TC("confirmed.short")} {<IconBool value={item.ack} />}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-1">
                    <div className="col-12">
                        <CopyToClipTextarea value={item.payload} />
                    </div>
                </div>
                <ConditionalRender condition={showError}>
                    <div className="row mt-3 mb-3">
                        <div className="col-12">
                            <div className="alert alert-warning"></div>
                        </div>
                    </div>
                </ConditionalRender>
            </Modal.Body>
            <Modal.Footer>
                <ConditionalRender condition={item.status}>
                    <Button variant="success" onClick={handleClean}>
                        {_TC("clean")}
                    </Button>
                </ConditionalRender>
                <Button variant="secondary" onClick={handleClose}>
                    {_TC("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalViewPayload;
